export default {
  label: 'CPF',
  hint: 'La tua banca richiede il tuo CPF per questo pagamento. Lo trasmettiamo senza conservarlo.',
  invalid: 'Non è un CPF valido. Controlla le 11 cifre.',
};
